import Avatar from './view/avatar';
import TextAvatar from './view/text';
import ImageAvatar from './view/image';
import ClusterAvatar from './view/cluster';
import GroupAvatar from './view/group';

Avatar.TextAvatar = TextAvatar;
Avatar.ImageAvatar = ImageAvatar;
Avatar.ClusterAvatar = ClusterAvatar;
Avatar.GroupAvatar = GroupAvatar;

export default Avatar;
